import { type KeyboardEvent } from 'react'
import { observer } from 'mobx-react-lite'
import { type Observable } from 'rxjs'
import { type DateTimeQuestionAnswerEditorViewModel } from '@/features/jobs/questions/date-time/DateTimeQuestionAnswerEditorViewModel'
import { DateTimeQuestionAnswerEditor } from '@/features/jobs/questions/date-time/components/DateTimeQuestionAnswerEditor'

export interface DateTimeQuestionAnswerEditorContainerProps {
  editorVm: DateTimeQuestionAnswerEditorViewModel
  questionId: string
  isDisabled: boolean
  focus$?: Observable<unknown>
  onFocus?: () => unknown
  onEnterDown?: (e: KeyboardEvent) => unknown
  isNotValid?: boolean
}

export const DateTimeQuestionAnswerEditorContainer = observer(
  function DateTimeQuestionAnswerEditorContainer({
    editorVm,
    questionId,
    ...rest
  }: DateTimeQuestionAnswerEditorContainerProps) {
    return (
      <DateTimeQuestionAnswerEditor
        value={editorVm.value}
        collectTime={editorVm.collectTime}
        minDate={editorVm.minDate}
        maxDate={editorVm.maxDate}
        onChange={editorVm.respond}
        testId={
          editorVm.collectTime
            ? `datetime-answer-${questionId}`
            : `date-answer-${questionId}`
        }
        {...rest}
      />
    )
  },
)
